import React, { memo } from 'react'
import PropTypes from 'prop-types'
import PhoneInput from 'react-phone-input-2'

import Label from 'components/forms/label'
import ErrorText from 'components/forms/errorMsg'
import StyledInput from 'components/forms/styledInput'
import 'react-phone-input-2/lib/style.css'

const Input = ({ label, name, onChange, onBlur, errors, touched, disabled, type, value, placeholder, helpText, sm, xs, phone, autoComplete, xl }) => {
  const isError = errors && touched

  const TextStyle = {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '10px',
    lineHeight: '15px'
  }

  return (
    <div className="mb-20">
      <Label id={name} label={label} helpText={helpText} />
      { phone
        ? <PhoneInput
            value={value || '+44'}
            onBlur={onBlur}
            onChange={(ph) => onChange(name, ph)}
            specialLabel=''
            autocompleteSearch={true}
            copyNumbersOnly={false}
            containerClass={isError ? 'error' : null}
            inputProps={{
              id: name,
              type,
              disabled,
              placeholder,
              'data-test': name
            }}
            inputClass={disabled ? 'input-phone-disabled' : 'input-phone'}
            dropdownStyle={TextStyle}
            searchStyle={TextStyle}
            buttonClass="input-phone-btn"
            autoFormat
            enableSearch />
        : <StyledInput
            id={name}
            data-test={name}
            type={type}
            value={value}
            onChange={onChange}
            error={isError}
            disabled={disabled}
            placeholder={placeholder}
            onBlur={onBlur}
            autoComplete={autoComplete}
            xs={xs}
            sm={sm}
            xl={xl} />
      }
      { isError ? <ErrorText>{ errors }</ErrorText> : null }
    </div>
  )
}

export default memo(Input)

Input.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  sm: PropTypes.bool,
  autoComplete: PropTypes.string,
  xs: PropTypes.bool,
  errors: PropTypes.string,
  xl: PropTypes.bool,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  touched: PropTypes.bool,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  helpText: PropTypes.string,
  phone: PropTypes.bool
}
